import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import { getPerspectiveId } from "@app/lib/perspective";
import CategorizePage, {
  categorizeQuery,
} from "@app/pages/categorize/categorize-page";
import type { categorizePage_Query } from "@app/queries/categorizePage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/categorize")({
  loader: () =>
    loadQuery<categorizePage_Query>(
      environment,
      categorizeQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        from: dateRangeFromISO(getDateRange()) ?? undefined,
      },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Categorize"),
  component: CategorizeRoute,
});

function CategorizeRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">
          Error loading the categorize board
        </div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading counterparties...</div>
        }
      >
        <CategorizePage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
